import { LogoutButton } from '@widgets/header/logout-button';
import SminexText from '@widgets/header/sminex-text';
import EventText from '@widgets/header/event-text';
import * as stylex from '@stylexjs/stylex';
import { Link } from 'react-router-dom';
import { styles } from './styles';

interface PageHeaderProps {
  isPreviewTemplate?: boolean;
}

export const PageHeader = ({ isPreviewTemplate }: PageHeaderProps) => (
  <nav {...stylex.props(styles.container, isPreviewTemplate && styles.containerPreviewTemplate)}>
    <Link to="/" {...stylex.props(styles.logo)}>
      <SminexText />
      <EventText />
    </Link>

    <LogoutButton />
  </nav>
);
